import Vue from "vue";

Vue.prototype.$availablematerialacc = [
  "matacc0",
  "matacc1",
  "matacc2",
  "matacc3",
  "matacc4",
  "matacc5",
  "matacc6",
  "matacc7",
  "matacc8",
  "matacc9",
  "matacc10"
];
